export const  AUTH_SET_USER = 'AUTH_SET_USER'
export const  AUTH_CLEAR_USER = 'AUTH_CLEAR_USER'
